import React, { Fragment, useState } from "react"
import { Table, Button } from "react-bootstrap"
import ModalAddUser from "./ModalAddUser"
import { saveUserTricel } from "./../../services/user.service"
import { toast } from "react-toastify"
import { isValidRut } from "../../utils"
const TableUsersRef = ({ users, unidad, setUsers, userExists }) => {
	const [showModalAdd, setShowModalAdd] = useState(false)
	const [loaderAdd, setLoaderAdd] = useState(false)
	const [addedUser, setAddedUser] = useState("")

/* 	const rutNoValid = userRut => {
		if (!isValidRut(addedUser)) {
			toast.warning("El rut ingresado no es válido")
			return true
		}
    
    if (userExists(userRut)) {
			toast.warning("El Rut ingresado ya se encuentra registrado")
			return true
		}

		return false
	} */

/* 	const handleSubmitAddUser = async e => {
		e.preventDefault()
		const userRut = addedUser.slice(0, addedUser.length - 1)
		if (rutNoValid(userRut)) return

		setLoaderAdd(true)
		const res = await saveUserTricel(userRut, unidad)
		if (res?.response === "success") {
			toast.info("Usuario guardado correctamente")
			setUsers([...users, res.data])
		} else {
			toast.warning(res?.message || "Ha ocurrido un error al guardar.")
		}
		setLoaderAdd(false)
		setShowModalAdd(false)
		console.log(res)
	} */

	return (
		<div className="mb-5">
			<Table bordered responsive>
				<thead className="">
					<tr>
						<th colSpan="5">
							Registro de usuarios habilitados en Padrón que no han iniciado sesión
						</th>
					</tr>
				</thead>
				<thead>
					<tr>
						<th>N°</th>
						<th>RUN</th>
						{/* <th>Cod. Unidad</th> */}
					</tr>
				</thead>
				<tbody>
					{users?.map((user, index) => {
						return (
							<tr key={index}>
								<td>{index + 1}</td>
								<td>{user.run_user}</td>
								{/* <td>{user.cod_unidad}</td> */}
							</tr>
						)
					})}
				</tbody>
			</Table>
{/* 			<Button className="float-right" onClick={() => setShowModalAdd(true)}>
				Agregar Usuario
			</Button>
			<ModalAddUser
				show={showModalAdd}
				setShow={setShowModalAdd}
				loader={loaderAdd}
				handleSubmit={handleSubmitAddUser}
				setUser={setAddedUser}
			/> */}
		</div>
	)
}

export default TableUsersRef
